module.exports = __webpack_public_path__ + "static/media/info_icon.2f6079f5.svg";